import { listTags } from '@/features/atendimento/api';
import { listAccessGroups } from '@/features/configuracoes/api';
import { useQuery } from '@tanstack/react-query';

/**
 * Tags com escopo `contact` ou `both` — usadas no filtro/atribuição em /contatos
 * E na ficha do contato dentro do /atendimento.
 *
 * NÃO vence por tempo. O prazo de 60s daqui era o pior tipo de custo: a ficha do
 * contato fica montada junto com a conversa (ThreadPanel:1140, com o `if (!open)`
 * DEPOIS do hook), então abrir uma conversa disparava esta busca sem ninguém ter
 * pedido etiqueta nenhuma. E ainda entregava lista de até 1min atrás pra quem
 * abria a ficha de verdade.
 *
 * Agora quem busca é `useRefetchOnOpen` em cada ponto de uso: ficha do contato,
 * filtro de etiqueta em /contatos, modal de criar/editar e o de importar.
 */
export function useContactTags() {
  return useQuery({
    queryKey: ['tags-contacts'],
    queryFn: async () => {
      const all = await listTags();
      return all.filter((t) => t.scope === 'contact' || t.scope === 'both');
    },
    staleTime: Number.POSITIVE_INFINITY,
  });
}

/** Grupos de acesso (empresas) do tenant — usados no import + filtro de campanha. */
export function useAccessGroups() {
  return useQuery({
    queryKey: ['access-groups'],
    queryFn: listAccessGroups,
    staleTime: 60_000,
  });
}
